// Add custom autorotate
let count = 0;
const maxRuns = 50;
const interval = setInterval(() => {
  const swipers = document.querySelectorAll('.swiper.at-swiper-ann-bar-autorotate');
  if (swipers[0]?.swiper) {
    Array.from(swipers).forEach((swiperNode) => {
      // skip hidden sliders (e.g. desktop slider on mobile viewport)
      if (swiperNode.offsetWidth === 0) return;

      const swiperRef = swiperNode.swiper;
      // count total width of original slides
      let total = 0;
      Array.from(swiperRef.slides).forEach((slide, i) => {
        total += slide.offsetWidth;
        if (i < swiperRef.slides.length - 1) {
          total += swiperRef.params.spaceBetween;
        }
      });
      // clone slides once for seamless loop
      const wrapper = swiperNode.querySelector('.swiper-wrapper');
      [...wrapper.children].forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.classList.add('clone');
        clone.setAttribute('aria-hidden', 'true');
        wrapper.appendChild(clone);
      });
      // unique class per slider instance — prefixed so it's always a valid CSS class
      const uid = 'ann-bar-' + Math.random().toString(36).slice(2);
      swiperNode.classList.add(uid);
      // duration proportional to content width so speed is consistent across viewports
      const speed = parseFloat(swiperNode.getAttribute('data-speed'));
      const duration = total / (speed * 10);
      const style = document.createElement('style');
      style.textContent = `
        @keyframes scrollSlides-${uid} {
          0% { transform: translateX(0); }
          100% { transform: translateX(-${total}px); }
        }
        .${uid} .swiper-wrapper.css-autoplay {
          animation: scrollSlides-${uid} ${duration}s linear infinite;
        }
      `;
      document.head.appendChild(style);
      wrapper.classList.add('css-autoplay');
    });

    clearInterval(interval);
  }
  if (count >= maxRuns) clearInterval(interval);
  count += 1;
}, 250);
